import { useEffect } from "react";

type Props = {
    fontFamily: string;
    weights?: string[];
};

export function GoogleFontLoader({
    fontFamily,
    weights = ["400", "500", "600", "700"],
}: Props) {
    useEffect(() => {
        if (!fontFamily) return;

        const formattedFamily = fontFamily.split(",")[0].replace(/['"]/g, "").trim();
        const linkId = `google-font-${formattedFamily.replace(/\s+/g, "-").toLowerCase()}`;

        if (document.getElementById(linkId)) return;

        const link = document.createElement("link");
        link.id = linkId;
        link.rel = "stylesheet";
        link.href = `https://fonts.googleapis.com/css2?family=${formattedFamily.replace(
            /\s+/g,
            "+"
        )}:wght@${weights.join(";")}&display=swap`;

        document.head.appendChild(link);

        return () => {
            // Optional: Clean up if needed
            // const element = document.getElementById(linkId);
            // if (element) {
            //   document.head.removeChild(element);
            // }
        };
    }, [fontFamily, weights]);

    return null;
}
